import {
  BillingCyclesApiGetTaxationEstimateRequest,
  BillingCyclesApiUpdateTaxationCategoryRequest,
  CACHE_KEYS,
  TaxationEstimate,
  TaxationEstimateList,
  buildBillingCyclesApiWithToken,
} from "@rentablo/api/apiv1";
import {
  useAuthQuery,
  useAuthMutation,
  UseQueryExtendedOptions,
} from "@rentablo/api";

const getTaxEstimate = async (
  params: BillingCyclesApiGetTaxationEstimateRequest
) => {
  const billingCycleApi = await buildBillingCyclesApiWithToken();

  const { data } = await billingCycleApi.getTaxationEstimate(params);
  return data;
};

export const useTaxEstimate = (
  params: BillingCyclesApiGetTaxationEstimateRequest,
  options: UseQueryExtendedOptions<
    TaxationEstimateList,
    AxiosApiError,
    TaxationEstimateList
  >
) => {
  return useAuthQuery(
    [CACHE_KEYS.GET_TAXATION_ESTIMATE, params],
    () => getTaxEstimate(params),
    options
  );
};

export const useUpdateTaxationCategory = (
  options?: UseQueryExtendedOptions<
    TaxationEstimate,
    AxiosApiError,
    TaxationEstimate
  >
) => {
  return useAuthMutation(
    async (
      token: string | undefined,
      params: BillingCyclesApiUpdateTaxationCategoryRequest
    ) => {
      const billingCycleApi = await buildBillingCyclesApiWithToken();

      const { data } = await billingCycleApi.updateTaxationCategory(params);
      return data;
    }
  );
};
